import React, { forwardRef } from 'react';
import '../../styles/icons.scss';
import PropTypes from 'prop-types';
import icons from './Icons';

const sizeClassMap = {
  xs: 'icon-xs',
  sm: 'icon-sm',
  md: 'icon-md',
  lg: 'icon-lg',
  xl: 'icon-xl',
  '2xl': 'icon-2xl',
  '3xl': 'icon-3xl',
  '4xl': 'icon-4xl',
  '5xl': 'icon-5xl',
  '6xl': 'icon-6xl',
};

export const Icon = forwardRef(
  ({ name, size = 'md', className = '', title, ...props }, ref) => {
    const IconComponent = icons[name];

    if (!IconComponent) {
      console.warn(`Icon '${name}' not found in icons:`, Object.keys(icons));
      return null;
    }

    const sizeClass = sizeClassMap[size] || '';

    return (
      <IconComponent
        ref={ref}
        className={`icon ${sizeClass} ${className}`}
        role='img'
        aria-hidden={!title}
        aria-label={title}
        {...props}
      />
    );
  }
);

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([
    PropTypes.oneOf([
      'xs',
      'sm',
      'md',
      'lg',
      'xl',
      '2xl',
      '3xl',
      '4xl',
      '5xl',
      '6xl',
    ]),
    PropTypes.string,
  ]),
  className: PropTypes.string,
  title: PropTypes.string,
};

Icon.displayName = 'Icon';
